<template>
  <div class="page page-section">
    <div class="flex items-center v-my-sm">
      <span></span>
      <div class="v-ml-auto">
        <a-button icon="user-add" type="primary" class="v-ml-md" size="small" @click="openEdit(-1)">添加角色</a-button>
      </div>
    </div>
    <div class="list-table-container">
      <a-table :bordered="false" size="small" :columns="columns" :data-source="list" :scroll="{ x: '100%' }" rowKey="id" :pagination="false">
        <template slot="action" slot-scope="text, record">
          <a-space class="table-actions" :gutter="10">
            <span class="table-action" @click="openEdit(record.id)" title="编辑"><a-icon type="form" /></span>
            <span class="table-action" @click="openMenuPermission(record.id, record.roleName)" title="权限配置"><a-icon type="funnel-plot" /></span>
            <a-popconfirm title="确定删除该角色?" ok-text="是" cancel-text="否" @confirm="del(record.id)">
              <span class="table-action text-red" title="删除"><a-icon type="close" /></span>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </div>
    <RoleEditForm ref="RoleEditForm" />
    <MenuPermission ref="MenuPermission" />
  </div>
</template>

<script>
import { roleList, deleteRole } from '@/api/system/role'
import RoleEditForm from './role-edit-form'
import MenuPermission from './role-menu-permission'
export default {
  components: { RoleEditForm, MenuPermission },
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          width: 60,
          align: 'center',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '角色代码',
          dataIndex: 'roleKey',
          align: 'center',
          // width: 130,
        },
        {
          title: '角色名称',
          dataIndex: 'roleName',
          align: 'center',
          // width: 130,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ],
      list: [],
    }
  },
  methods: {
    openEdit(id) {
      if (id < 0) {
        this.$refs.RoleEditForm.open()
      } else {
        this.$refs.RoleEditForm.open(id)
      }
    },
    openMenuPermission(id, roleName) {
      this.$refs.MenuPermission.open(id, roleName)
    },
    del(id) {
      deleteRole(id).then(({ data }) => {
        if (data.success) {
          this.$message.success('删除成功')
          this.dataLoad()
        }
      })
    },
    dataLoad() {
      roleList().then((response) => {
        this.list = response.data.result
      })
    },
  },
  mounted() {
    this.dataLoad()
  },
}
</script>
